import { parseDate, displayDate } from '../../services/dates/dateService';

import { CalendarDatePicker } from '../common/CalendarDatePicker';

import React, { Component } from 'react';

import { Redirect } from 'react-router';

import { Link } from 'react-router-dom';

import '../common/MdPage.css';

import Select from '../common/AppSelect';

import { findSelectOptionByValue } from '../../services/selectOptions';

import * as constantClass from '../fileWithConstants';

import { ChevronLeftIcon } from '../common/mdPageIcons';

import * as historiaAcademicaService from '../../services/historiaAcademica/historiaAcademicaService';

import {

  classifyHistoriaAcademicaError,

  getResultadoCursadaLabel,

  hasFechaFinRegularidad,

  isSentinelRegularidadDate,

  normalizeResultadoCursada,

  RESULTADO_CURSADA_OPTIONS,

  toUpdateHistoriaAcademicaCursadaPayload,

  validateUpdateHistoriaAcademicaCursadaForm,

} from '../../services/historiaAcademica/historiaAcademicaDto';



const options = RESULTADO_CURSADA_OPTIONS;



function resolveFechaFinRegularidad(resultado, fechaFinRaw) {

  if (!hasFechaFinRegularidad(resultado)) {

    return null;

  }

  if (isSentinelRegularidadDate(fechaFinRaw)) {

    return null;

  }

  return parseDate(fechaFinRaw);

}



export class UpdateHistoriaAcademicaCursada extends Component {

  static displayName = UpdateHistoriaAcademicaCursada.name;



  constructor(props) {

    super(props);

    this.state = {

      loading: false,

      loadingData: true,

      showErrorMessage: false,

      success: false,

      errorMessage: '',

      anio: { anioAcademicoCod: 0, anioAcademicoDescripcion: '', carrera: '' },

      materia: { codigo: 0, anioAcademicoDescripcion: '' },

      id: this.props.match.params.id,

      details: this.props.match.params.details,

      fecha: null,

      fechaFinRegularidad: null,

      observaciones: '',

      resultado: '',

      valueDictado: { value: '', label: '' },

    };

  }



  async componentDidMount() {

    const canAccess = await constantClass.canAccess('HistoriaAcademicaCursada');

    if (canAccess) {

      await this.populateData();

    }

  }



  handleConfirmButton = () => {

    const validation = validateUpdateHistoriaAcademicaCursadaForm({

      resultado: this.state.resultado,

      fecha: this.state.fecha,

      fechaFinRegularidad: this.state.fechaFinRegularidad,

    });



    if (!validation.valid) {

      this.setState({

        showErrorMessage: true,

        errorMessage: validation.message,

      });

      return;

    }



    this.saveStudent();

  };



  handleHistoriaAcademicaError(error) {

    const outcome = classifyHistoriaAcademicaError(error);

    if (outcome.type === 'timeout') {

      constantClass.RedirectToLogin();

      return { success: false, errorMessage: '' };

    }

    return {

      success: false,

      errorMessage: outcome.message

    };

  }



  async populateData() {

    this.setState({ loadingData: true });

    try {

      const model = await historiaAcademicaService.getHistoriaAcademicaCursada(this.state.id);

      const resultado = normalizeResultadoCursada(model.historiaAcademicaResultado);

      const defaultValueAnioDictado = findSelectOptionByValue(options, resultado);



      this.setState({

        loadingData: false,

        errorMessage: '',

        showErrorMessage: false,

        anio: {

          anioAcademicoCod: model.alumnoxCarreraCod,

          anioAcademicoDescripcion: model.alumnoxCarreraCodNavigation.alumnoNombre.trim(),

          carrera: model.alumnoxCarreraCodNavigation.carreraNombre.trim()

        },

        materia: {

          codigo: model.materiaCarreraCod,

          anioAcademicoDescripcion: model.materiaCarreraCodNavigation.materiaCarreraNombre.trim()

        },

        resultado,

        fecha: parseDate(model.historiaAcademicaFecha),

        observaciones: model.historiaAcademicaCursadaObserv ? model.historiaAcademicaCursadaObserv.trim() : '',

        fechaFinRegularidad: resolveFechaFinRegularidad(resultado, model.historiaAcademicaFechaFinRegul),

        valueDictado: defaultValueAnioDictado

      });

    } catch (error) {

      const outcome = this.handleHistoriaAcademicaError(error);

      this.setState({

        loadingData: false,

        errorMessage: outcome.errorMessage,

      });

    }

  }



  handleStartDate = (date) => {

    this.setState({

      fechaFinRegularidad: date,

      showErrorMessage: false,

      errorMessage: '',

    });

  };



  handleDictadoChangeInput = (e) => {

    const resultado = normalizeResultadoCursada(e.value);

    const updates = {

      resultado,

      valueDictado: e,

      showErrorMessage: false,

      errorMessage: '',

    };



    if (resultado === 'L') {

      updates.fechaFinRegularidad = null;

    }



    this.setState(updates);

  };



  handleNameChangeInput = (e) => {

    this.setState({ observaciones: e.target.value });

  };



  handleFechaExamen = (date) => {

    this.setState({

      fecha: date,

      showErrorMessage: false,

      errorMessage: '',

    });

  };



  renderFechaFinRegularidad(isDetail, loading) {

    const requiresFechaFin = hasFechaFinRegularidad(this.state.resultado);

    const fechaFinDisplay = requiresFechaFin && !isSentinelRegularidadDate(this.state.fechaFinRegularidad)

      ? displayDate(this.state.fechaFinRegularidad)

      : '';



    if (isDetail) {

      return (

        <div className="md-page__field-readonly">

          {fechaFinDisplay || '\u00a0'}

        </div>

      );

    }



    return (

      <CalendarDatePicker

        className="md-page__field-input"

        selected={this.state.fechaFinRegularidad}

        onChange={this.handleStartDate}

        disabled={loading || !requiresFechaFin}

      />

    );

  }



  render() {

    if (this.state.success) {

      return <Redirect to="/md-hic" />;

    }



    const isDetail = this.state.details !== '0';

    const title = isDetail ? 'Detalle de Historia Académica Cursada' : 'Modificar Historia Académica Cursada';

    const { loading, loadingData } = this.state;

    const isBusy = loading || loadingData;

    const alumnoDisplay = (`${this.state.anio.anioAcademicoDescripcion} - ${this.state.anio.carrera}`).trim();

    const materiaDisplay = this.state.materia.anioAcademicoDescripcion.trim();

    const resultadoLabel = getResultadoCursadaLabel(this.state.resultado);



    return (

      <div className="md-page md-update-historia-cursada">

        <Link className="md-page__back-link" to="/md-hic">

          <ChevronLeftIcon />

          Volver al listado

        </Link>



        <div className="md-page__header">

          <h1 className="md-page__title">{title}</h1>

        </div>

        <p className="md-page__subtitle">

          {isDetail

            ? 'Consulte los datos registrados de la historia académica.'

            : 'Actualice los datos de la historia académica y guarde los cambios.'}

        </p>



        <div className="md-page__feedback" aria-live="polite" role="status">

          {this.state.showErrorMessage ? (

            <div className="md-page__error" role="alert">{this.state.errorMessage}</div>

          ) : null}

          {this.state.errorMessage && !this.state.showErrorMessage ? (

            <div className="md-page__error" role="alert">{this.state.errorMessage}</div>

          ) : null}

          {loadingData ? (

            <div className="md-page__status">Cargando datos...</div>

          ) : null}

          {loading ? (

            <div className="md-page__status">Los datos se están actualizando, espere unos segundos...</div>

          ) : null}

        </div>



        <div className="md-page__form-card">

          <div className="md-page__field">

            <span className="md-page__field-label">Alumno</span>

            <div className="md-page__field-readonly">{alumnoDisplay || '\u00a0'}</div>

          </div>



          <div className="md-page__field">

            <span className="md-page__field-label">Materia</span>

            <div className="md-page__field-readonly" title={materiaDisplay}>

              {materiaDisplay || '\u00a0'}

            </div>

          </div>



          <div className="md-page__field">

            <span className="md-page__field-label">Fecha de cursada</span>

            {isDetail ? (

              <div className="md-page__field-readonly">{displayDate(this.state.fecha) || '\u00a0'}</div>

            ) : (

              <CalendarDatePicker

                className="md-page__field-input"

                selected={this.state.fecha}

                onChange={this.handleFechaExamen}

                disabled={isBusy}

              />

            )}

          </div>



          <div className="md-page__field">

            <span className="md-page__field-label">Resultado</span>

            {isDetail ? (

              <div className="md-page__field-readonly">{resultadoLabel || '\u00a0'}</div>

            ) : (

              <Select

                className="md-page__field-select"

                value={this.state.valueDictado}

                options={options}

                onChange={this.handleDictadoChangeInput}

                disabled={isBusy}

              />

            )}

          </div>



          <div className="md-page__field">

            <span className="md-page__field-label">Fecha de fin de regularidad</span>

            {this.renderFechaFinRegularidad(isDetail, isBusy)}

          </div>



          <div className="md-page__field">

            <label className="md-page__field-label" htmlFor="historia-observaciones">

              Observaciones

            </label>

            {isDetail ? (

              <div className="md-page__field-readonly" id="historia-observaciones">

                {this.state.observaciones || '\u00a0'}

              </div>

            ) : (

              <input

                id="historia-observaciones"

                className="md-page__field-input"

                name="observaciones"

                placeholder="Ingrese observaciones"

                onChange={this.handleNameChangeInput}

                disabled={isBusy}

                value={this.state.observaciones}

              />

            )}

          </div>



          {!isDetail ? (

            <div className="md-page__form-actions">

              <button

                type="button"

                className="md-page__form-btn md-page__form-btn--primary"

                onClick={this.handleConfirmButton}

                disabled={isBusy}

              >

                Guardar cambios

              </button>

            </div>

          ) : null}

        </div>

      </div>

    );

  }



  async saveStudent() {

    this.setState({ showErrorMessage: false, loading: true });

    try {

      const fechaFinRegularidad = hasFechaFinRegularidad(this.state.resultado)

        ? this.state.fechaFinRegularidad

        : null;



      await historiaAcademicaService.updateHistoriaAcademicaCursada(

        toUpdateHistoriaAcademicaCursadaPayload({

          id: this.state.id,

          resultado: this.state.resultado,

          fecha: this.state.fecha,

          fechaFinRegularidad,

          observaciones: this.state.observaciones

        })

      );

      this.setState({ loading: false, success: true, errorMessage: '' });

    } catch (error) {

      const outcome = this.handleHistoriaAcademicaError(error);

      this.setState({

        loading: false,

        success: false,

        showErrorMessage: true,

        errorMessage: outcome.errorMessage,

      });

    }

  }

}


